export default __webpack_public_path__ + "static/media/Orders_Mobile.3b646ae0.svg";